/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type {FileContentResult} from '../models/FileContentResult';
import type {UsageStatsResponse} from '../models/UsageStatsResponse';
import type {CancelablePromise} from '../core/CancelablePromise';
import type {BaseHttpRequest} from '../core/BaseHttpRequest';
export class UsageStatsService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Get all dashboard usage data for the specified time period.
   * Supports period shortcuts (current, last30, last60, last90) or an explicit from/to range.
   * @returns UsageStatsResponse OK
   * @throws ApiError
   */
  public usageStatsGetUsageStats({
    period = 'current',
    from,
    to,
  }: {
    period?: string;
    from?: string;
    to?: string;
  }): CancelablePromise<UsageStatsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/usage-stats',
      query: {
        period: period,
        from: from,
        to: to,
      },
      errors: {
        401: `Unauthorized`,
      },
    });
  }
  /**
   * Export usage data as CSV. Includes summary, per-feature breakdown, and transaction details.
   * @returns FileContentResult OK
   * @throws ApiError
   */
  public usageStatsExportCsv({
    period = 'current',
    from,
    to,
  }: {
    period?: string;
    from?: string;
    to?: string;
  }): CancelablePromise<FileContentResult> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/usage-stats/export',
      query: {
        period: period,
        from: from,
        to: to,
      },
      errors: {
        401: `Unauthorized`,
      },
    });
  }
}
